import { clientJump, isJSBridge } from './index';
import { authorityCheck } from './authority';

//数据导出类型
export const sourcePage = {
  company_search: 'company_search', //企业搜索
  company_around: 'company_around', // 附近企业,
  newly_establish_enterprise: 'newly_establish_enterprise', // 新成立企业,
  bank_expansion: 'bank_expansion', //银行拓客,
  industry_chain_data: 'industry_chain_data', //产业链数据,
  billboard_data: 'billboard_data', //榜单数据,
  park_data: 'park_data', //园区数据,
  technology_enterprise: 'technology_enterprise', //科技型企业
  equity_graph: 'equity_graph', //股权图谱
  address_book: 'industry_boss_address_book', //行业老板通讯录
  find_customer: 'find_customer_enterprise', // 找客户
  due_diligence: 'due_diligence', // 企业尽调报告
};

export const exportType = {
  statistics: 'statistics', //数据导出
  report: 'report', // 报告导出,
  newly_e_e: 'newly_e_e', // 新成立企业,
  bank_expansion: 'bank_expansion', //银行拓客,
  industry_c_d: 'industry_c_d', //产业链数据,
  billboard_data: 'billboard_data', //榜单数据,
  park_data: 'park_data', //园区数据,
  technology_e: 'technology_e', //科技型企业
  equity_graph: 'equity_graph', //股权图谱
  address_book: 'address_book', // 行业老板通讯录
  find_customer: 'f_c_e', // 找客户
  due_diligence: 'due_diligence', // 企业尽调报告
};

// key为exportType
export const exportLimitTypes = {
  newly_e_e: 'limit_type_xclqydc', //新成立企业
  bank_expansion: 'limit_type_yhtkdc', //银行拓客
  industry_c_d: 'limit_type_cylsjdc', //产业链数据
  billboard_data: 'limit_type_bdsjdc', //榜单数据
  park_data: 'limit_type_yqsjdc', //园区数据
  technology_e: 'limit_type_kjqydc', //科技企业
  equity_graph: 'limit_type_qygqtpdc', //股权图谱
  address_book: 'limit_type_hylbtxl_sjdc', // 行业老板通讯录
  f_c_e: 'limit_type_zkhsjdc', // 找客户
  due_diligence: 'limit_type_qyjdbg', // 企业尽调报告
  member: 'limit_type_member', // 会员无限次 判断是否会员
};

/**
 * jumpExportData
 * @param {*} title 标题
 * @param {*} exportType 导出类型
 * @param {*} sourcePage service_type
 * @param {*} count 数量
 * @param {*} searchParam 页面列表请求参数
 */
export function jumpExportData(
  title,
  exportType,
  sourcePage,
  count,
  searchParam,
  record_id,
  extraParams = {}
) {
  let transferExport = {
    title: title,
    exportType: exportType,
    sourcePage: sourcePage,
    count: count,
    searchParam: searchParam,
    record_id: record_id,
  };
  // console.log('exportData-param', transferExport);
  localStorage.setItem('exportTransfer', JSON.stringify(transferExport));
  const { skipJudege } = extraParams;
  if (skipJudege) {
    // 跳过校验
    clientJump(
      window.location.origin + '/yuqingwebapp/yuqingapp/#/exportModule/exportPlugin?source=h5',
      0,
      false
    );
  } else {
    if (isJSBridge()) {
      let newParams = { needCloseH5: false };
      let schemeParams = {
        url:
          window.location.origin + '/yuqingwebapp/yuqingapp/#/exportModule/exportPlugin?source=h5',
        title: title,
        webViewDisplayStyle: 2,
        errorViewType: 2,
      };
      newParams.scheme_url = `kuaicha://WebPage?extraData=${encodeURIComponent(
        JSON.stringify(schemeParams)
      )}&limitType=${exportLimitTypes[exportType]}`;
      console.log('goExportData-limit', 'openPage', newParams);
      window.callNativeHandler('openPage', newParams);
    } else {
      console.log('sdk-导出');
      const cb = () => {
        clientJump(
          window.location.origin + '/yuqingwebapp/yuqingapp/#/exportModule/exportPlugin?source=h5',
          0,
          false
        );
      };
      authorityCheck('DATA_EXPORT', cb);
    }
  }
}
